"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meterReadingYourBenefitsPropTypes = exports.meterReadingRegisterLabelPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var meterReadingYourBenefitsPropTypes = exports.meterReadingYourBenefitsPropTypes = {
  paperlessCommunication: _propTypes.default.string.isRequired,
  meterShow: _propTypes.default.string.isRequired,
  meterRemind: _propTypes.default.string.isRequired,
  consumptionHistory: _propTypes.default.string.isRequired,
  addressChangeOnline: _propTypes.default.string.isRequired
};
var meterReadingRegisterLabelPropTypes = exports.meterReadingRegisterLabelPropTypes = {
  onlyGuestPortal: _propTypes.default.bool.isRequired,
  withoutRegisterText: _propTypes.default.string.isRequired,
  withoutRegisterButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    version: _propTypes.default.string
  }).isRequired,
  readingCardHeadline: _propTypes.default.string.isRequired,
  readingCardSubline: _propTypes.default.string.isRequired,
  registerForPortalHeadline: _propTypes.default.string.isRequired,
  registerForPortalSubline: _propTypes.default.string.isRequired,
  yourBenefitsText: _propTypes.default.string.isRequired,
  yourBenefits: _propTypes.default.shape(meterReadingYourBenefitsPropTypes).isRequired,
  activateButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    version: _propTypes.default.string
  }).isRequired,
  registerButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    version: _propTypes.default.string
  }).isRequired,
  dataProtectionPageUrl: _propTypes.default.string.isRequired,
  dataProtectionLabel: _propTypes.default.string.isRequired,
  dataProtectionText1: _propTypes.default.string.isRequired,
  dataProtectionText2: _propTypes.default.string.isRequired
};